// extracted by mini-css-extract-plugin
module.exports = {"editDetailsRoot":"editDetailsRoot--1d701","editDetailsLeftColumn":"editDetailsLeftColumn--34d42","editDetailsRightColumn":"editDetailsRightColumn--47692"};